// components
import { useEffect } from 'react'
import AssetSelect from './AssetSelect'

export default function AssetLoadsCarousel({dropdowns, handleFunc, newJob, setIsFixedCost, setIsFixedRev, isFixedCost, isFixedRev, changeFunc, setNewJob}) {
  // const [applyFsc, setApplyFsc] = useState(false)

  useEffect(() => {
    if (newJob) {
      if (newJob.fixed_mob_rev > 0) {
        setIsFixedRev(true)
      }
      if (newJob.fixed_mob_cost > 0) {
        setIsFixedCost(true)
      }
      // if (newJob.apply_fsc_to_asset_loads) {
      //   setApplyFsc(true)
      // }
    }
  }, [newJob, setIsFixedRev, setIsFixedCost])

  const handleChecked = (e) => {
    if (e.target.id === 'use-fixed-cost') {
      setIsFixedCost(!isFixedCost)
      setNewJob({
        ...newJob,
        vendor_equipment_rate_id: 0,
        vendor_empty_boxes_rate_id: 0,
        vendor_full_boxes_rate_id: 0,
        fixed_mob_cost: 0,
      })
    } else if (e.target.id === 'use-fixed-rev') {
      setIsFixedRev(!isFixedRev)
      setNewJob({
        ...newJob,
        customer_equipment_rate_id: 0,
        customer_empty_boxes_rate_id: 0,
        customer_full_boxes_rate_id:0,
        fixed_mob_rev: 0,
      })
    }
  }

  // const handleFSC = () => {
  //   setApplyFsc(!applyFsc)
  //   setNewJob({
  //     ...newJob,
  //     apply_fsc_to_asset_loads: !applyFsc,
  //   })
  // }
  
  return(
    <div className='asset-dropdown-div'>
      <div className="mb-1 row field">
        <label className="col-sm-3 form-check-label" htmlFor="use-fixed-rev">
          Use Fixed Rev
          <input
              id="use-fixed-rev"
              type="checkbox"
              checked={isFixedRev}
              onChange={handleChecked}
              className="form-check-input"
              style={{
                borderColor: "black"
              }}
          />
        </label>
        <label className="col-sm-3 form-check-label" htmlFor="use-fixed-cost">
          Use Fixed Cost
          <input
              id="use-fixed-cost"
              type="checkbox"
              checked={isFixedCost}
              onChange={handleChecked}
              className="form-check-input"
              style={{
                borderColor: "black"
              }}
          />
        </label>
        {/* {newJob.fsc_area_id && <label className="col-sm-3 form-check-label" htmlFor="apply-fsc">
          Apply FSC
          <input
              id="apply-fsc"
              type="checkbox"
              checked={applyFsc}
              onChange={handleFSC}
              className="form-check-input"
              style={{
                borderColor: "black"
              }}
          />
        </label>} */}
      </div>
      <div className="mb-1 row field">
        {isFixedRev && 
          <>
            <label className="col-sm-2 col-form-label">Fixed Mob Rev</label>
              <input 
                id='fixed_mob_rev'
                name='fixed_mob_rev'
                type='number'
                step={0.01}
                onChange={changeFunc}
                placeholder='Enter Fixed Mob Rev'
                value={newJob['fixed_mob_rev']}
                className='col-auto'
                required
              />
          </>
        }
        {isFixedCost && 
          <>
            <label className="col-sm-2 col-form-label">Fixed Mob Cost</label>
              <input 
                id='fixed_mob_cost'
                name='fixed_mob_cost'
                type='number'
                step={0.01}
                onChange={changeFunc}
                placeholder='Enter Fixed Mob Cost'
                value={newJob['fixed_mob_cost']}
                className='col-auto'
                required
              />
          </>
        }
      </div>
      <div className="mb-1 row field">
        {(!isFixedRev) && 
          <AssetSelect 
            name={'customer_equipment_rate_id'}
            title={'Customer Equipment Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.customer_equipment_rate_id)}
          />
        }
        {(!isFixedCost) && 
          <AssetSelect 
            name={'vendor_equipment_rate_id'}
            title={'Vendor Equipment Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.vendor_equipment_rate_id)}
          />
        }
      </div>
      <div className="mb-1 row field">
        {(!isFixedRev) && 
          <AssetSelect 
            name={'customer_empty_boxes_rate_id'}
            title={'Customer Empty Boxes Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.customer_empty_boxes_rate_id)}
          />
        }
        {(!isFixedCost) && 
          <AssetSelect 
            name={'vendor_empty_boxes_rate_id'}
            title={'Vendor Empty Boxes Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.vendor_empty_boxes_rate_id)}
          />
        }
      </div>
      <div className="mb-1 row field">
        {(!isFixedRev) && 
          <AssetSelect 
            name={'customer_full_boxes_rate_id'}
            title={'Customer Full Boxes Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.customer_full_boxes_rate_id)}
          />
        }
        {(!isFixedCost) && 
          <AssetSelect 
            name={'vendor_full_boxes_rate_id'}
            title={'Vendor Full Boxes Rate'}
            options={dropdowns.asset_rates}
            onChange={handleFunc}
            maxMenuHeight={200}
            placeholder={'Equipment Rate'}
            value={dropdowns.asset_rates.filter(x => x.value === newJob.vendor_full_boxes_rate_id)}
          />
        }
      </div>

  </div>
  )
}